// frontend/src/utils/errorUtils.js

/**
 * Parses Axios API errors, checking for express-validator details arrays,
 * standard error strings, and i18n translation fallbacks.
 *
 * @param {Object} err - The error object caught from Axios.
 * @param {Function} [t] - Optional i18n translation function.
 * @param {string} [namespace='auth'] - Optional translation namespace prefix.
 * @returns {string} User-friendly error message.
 */
export const getErrorMessage = (err, t, namespace = 'auth') => {
  const resData = err?.response?.data;
  const firstDetail = resData?.details?.[0]?.msg;

  // Helper to safely check i18n translations
  const translateKey = (key) => {
    if (!t) return key;
    const fullKey = namespace ? `${namespace}.${key}` : key;
    const translated = t(fullKey);
    return translated !== fullKey ? translated : key;
  };

  // 1. express-validator field error details array
  if (firstDetail) {
    return translateKey(firstDetail);
  }

  // 2. Standard backend error or message string
  if (resData?.error || resData?.message) {
    return translateKey(resData.error || resData.message);
  }

  // 3. Fallback for server crashes, network errors, or CORS issues
  return t ? t('errors.serverError') : 'An unexpected error occurred. Please try again.';
};
